import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import QuickSubscribe from './components/QuickSubscribe';
import QuickSubscribeThanks from './components/QuickSubscribeThanks';
import Subscribe from './components/Subscribe';
import SubscribeThanks from './components/SubscribeThanks';
import UnsubscribeThanks from './components/UnsubscribeThanks';

function App() {
  const [size, setSize] = React.useState(window.innerWidth < 576 ? 'mobile' : 'desktop');

  React.useEffect(() => {
    function setWindowSize() {
      setSize(window.innerWidth < 576 ? 'mobile' : 'desktop');
    }

    window.addEventListener('resize', setWindowSize);
    return () => {
      window.removeEventListener('resize', setWindowSize);
    };
  }, []);

  return (
    <React.Fragment>
      <Route exact path='/QuickSubscribe' render={(props) => (
        <QuickSubscribe {...props} size={size} />
      )} />
      <Route exact path='/QuickSubscribeThanks' render={(props) => (
        <QuickSubscribeThanks {...props} size={size} />
      )} />
      <Route exact path='/Subscribe' render={(props) => (
        <Subscribe {...props} size={size} type="email" />
      )} />
      <Route exact path='/Unsubscribe' render={(props) => (
        <Subscribe {...props} size={size} type="email_unsubscribe" />
      )} />
      <Route exact path='/SubscribeThanks' render={(props) => (
        <SubscribeThanks {...props} size={size} />
      )} />
      <Route exact path='/UnsubscribeThanks' render={(props) => (
        <UnsubscribeThanks {...props} size={size} />
      )} />
      <Route exact path="/">
        <Redirect to={{ ...window.location, pathname: '/Subscribe' }} />
      </Route>
    </React.Fragment>
  );
}

export default App;
